import { useStaticQuery, graphql } from 'gatsby';

export const useLocalizedFaqs = selectedLocale => {
  const {
    allPrismicFaq: { edges: faqs },
  } = useStaticQuery(graphql`
    query {
      allPrismicFaq {
        edges {
          node {
            uid
            lang
            data {
              ...FaqDataFragment
            }
          }
        }
      }
    }
  `);

  return faqs.filter(({ node }) => node.lang === selectedLocale);
};
